<script>
import { consultingApiUrl, consultingApiKey } from '../../variables';
import axios from 'axios';

export default {
  name: 'ConversationAnswerForm',
  props: {
    conversationId: String
  },
  data() {
    return {
      isSaving: false,
      isSuccess: false,
      hasSendError: false,
      hasValidationError: false,
      model: {
        message: ''
      }
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.isSaving) return;

      this.hasValidationError = false;
      if (!this.model.message.length > 0) {
        this.hasValidationError = true;
        return;
      }

      this.isSaving = true;
      this.hasSendError = false;
      axios
        .post(
          `${consultingApiUrl}/conversation-items`,
          {
            conversation_id: this.conversationId,
            body: this.model.message
          },
          {
            headers: {
              Authorization: `Bearer ${consultingApiKey}`
            }
          }
        )
        .then(() => {
          this.isSaving = false;
          this.isSuccess = true;
        })
        .catch(() => {
          this.isSaving = false;
          this.hasSendError = true;
        });
    }
  }
};
</script>

<template>
  <div class="conversation-answer-form">
    <div class="conversation-answer-form__body">
      <!-- Form -->
      <form class="conversation-answer-form__form" action="" v-if="!isSuccess">
        <h2 class="conversation-answer-form__title">
          {{ $t('consultingConversation.conversationAnswerFormTitle') }}
        </h2>
        <p class="conversation-answer-form__lead">
          {{ $t('consultingConversation.conversationAnswerFormLead') }}
        </p>
        <p class="conversation-answer-form__send-error" v-if="hasSendError">
          {{ $t('consultingConversation.conversationAnswerFormSendError') }}
        </p>
        <label
          class="form-control form-control--textarea"
          v-bind:class="{
            'form-control--has-error': hasValidationError,
          }"
        >
          <span class="consulting-form__span form-control__label">{{
            $t('consultingForm.inputLabelMessage')
          }}</span>
          <textarea
            class="form-control__input"
            rows="12"
            v-model="model.message"
            required
          ></textarea>
          <div class="form-control__messages">
            <span
              class="form-control__message form-control__message--error"
              v-if="hasValidationError"
            >
              {{
                $t('consultingConversation.conversationAnswerFormValidation')
              }}
            </span>
          </div>
        </label>

        <div class="consulting-form__actions">
          <button
            class="consulting-form__button button button--primary"
            v-on:click="onSubmit($event)"
          >
            <span v-if="!isSaving">{{
              $t('consultingConversation.conversationAnswerFormButtonSave')
            }}</span
            ><span v-if="isSaving">{{
              $t('consultingConversation.conversationAnswerFormButtonLoading')
            }}</span>
          </button>
        </div>
      </form>
      <!-- Success -->
      <div class="conversation-answer-form__success" v-else>
        <p>Vielen Dank für Ihre Anfrage an die Angehörigenbegleitung von «Leben mit Schizophrenie».</p>
        <p>Hinweis: Bei akuten Notsituationen wenden Sie sich bitte an die Notfallnummern 144 (Notruf), 117 (Polizei) oder 147 (Telefonhilfe für Kinder und Jugendliche).</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.conversation-answer-form {
  position: relative;
  padding: 2.3rem 5rem;
  margin-top: 7rem;
  background-color: $color-card-background;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -1.1rem;
    top: 3.2rem;
    width: 2.2rem;
    height: 2.2rem;
    background-color: $color-card-background;
    transform: rotate(45deg);
  }
}

.conversation-answer-form__title {
  margin-top: 0;
}

.conversation-answer-form__body {
  font-size: 1.8rem;
  letter-spacing: 0.033rem;
  line-height: 1.56;
}

.conversation-answer-form__send-error {
  color: $color-danger;
}
</style>
